import { STATISTIQUE_ROUTES as statistiqueRoutes } from "~/api/routes";

export const state = () => ({
  statistics: {
    kpis: {},
    filtered_kpis: {},
    metrics : {}
  }
});

export const getters = {
  kpis: (state) => { return state.statistics.kpis },
  filtered_kpis: (state) => { return state.statistics.filtered_kpis },
  metrics: (state) => { return state.statistics.metrics }
};

export const mutations = {
  STATISTIQUE_KPIS(state, payload) {
    state.statistics.kpis = payload;
  },
  STATISTIQUE_FILTERED_KPIS(state, payload) {
    state.statistics.filtered_kpis = payload;
  },
  STATISTIQUE_METRICS(state, payload) {
    state.statistics.metrics = payload;
  }
};

export const actions = {
  async kpis({ commit }) {
    return new Promise((resolve, reject) => {
      this.$api.request(statistiqueRoutes.kpis)
        .then(response => {
            commit('STATISTIQUE_KPIS', response.payload);
            resolve();
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
        });
    })
  },
  async filtered_kpis({ commit }, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(statistiqueRoutes.kpisFiltered, {}, params)
        .then(response => {
          commit('STATISTIQUE_FILTERED_KPIS', response.payload);
          resolve();
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {

        });
    })
  },
  async metrics({ commit }, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(statistiqueRoutes.metrics, {}, params)
        .then(response => {
          commit('STATISTIQUE_METRICS', response.payload);
          resolve();
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
        });
    })
  }
};
